import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Auto = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <>
        <rect
          x='2.844'
          y='3.166'
          width='18.5'
          height='18.5'
          rx='3.25'
          stroke='currentColor'
          strokeWidth='1.5'
        />
        <path
          d='M8.064 17.416q-.395 0-.648-.18a.82.82 0 0 1-.309-.484q-.056-.304.127-.678l3.6-7.759q.226-.47.535-.678.31-.22.718-.221.407 0 .717.221.31.209.52.678l3.63 7.76q.183.373.127.69a.7.7 0 0 1-.282.485q-.24.166-.619.166-.478 0-.745-.221-.255-.221-.45-.692l-.844-1.922.872.594H9.147l.872-.594-.83 1.922q-.21.484-.45.706-.225.207-.675.207m3.995-7.593-1.801 4.218-.38-.54h4.403l-.38.54-1.814-4.218z'
          fill='currentColor'
        />
      </>
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.094 2.416a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4v-12a4 4 0 0 0-4-4zm1.322 14.82q.254.18.648.18.45 0 .675-.207.24-.222.45-.706l.573-1.328h4.64l.583 1.328q.195.47.45.692.267.22.745.221.38 0 .62-.166a.7.7 0 0 0 .28-.484q.057-.318-.126-.692l-3.63-7.759q-.21-.47-.52-.678a1.2 1.2 0 0 0-.717-.221q-.408 0-.718.221-.309.209-.534.678l-3.601 7.76q-.183.372-.127.677.07.304.31.484m3.072-3.734 1.57-3.68h.029l1.582 3.68z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
